import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadTimezonesEpic } from './_epics/loadTimezones.epic';

export const dictTimezoneEpic = safeCombineEpics(
  loadTimezonesEpic,
);
